import { ThemeProvider } from '@emotion/react';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import Toast from './components/Toast/Toast';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './services/auth/auth.service';
import theme from './theme';
import GlobalStyles from './utils/GlobalStyles/GlobalStyles';
import { store } from './app/store';
import AppRoutes from './routes/AppRoutes';
import { OptimizelyProvider } from './services/optimizely/OptimizelyProvider';

// Only import development auth setup if REACT_APP_DISABLE_AUTH_LOCAL is explicitly set to true
if (process.env.REACT_APP_DISABLE_AUTH_LOCAL && process.env.REACT_APP_DISABLE_AUTH_LOCAL === 'true') {
  // Import development auth setup for local development only
  alert('local auth is enabled - auth tokens will be auto-generated');
  import('./services/devAuth')
    .then(() => console.log('Development authentication enabled - auth tokens will be auto-generated'))
    .catch(err => console.error('Failed to load development authentication:', err));
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <OptimizelyProvider>
            <ThemeProvider theme={theme}>
              <GlobalStyles />
              <BrowserRouter>
                <Toast />
                <AppRoutes />
              </BrowserRouter>
            </ThemeProvider>
          </OptimizelyProvider>
        </AuthProvider>
      </QueryClientProvider>
    </Provider>  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
